import Message from './src/main.js';
export default Message;



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/message/index.js